module.exports = __webpack_public_path__ + "img/RKM.35e0e22c.png";